import { useDispatch, useSelector } from 'react-redux';
import { AppRouter } from './routes';
import { useEffect } from 'react';
import {
  appLoaded,
  getDataSessionRequest,
} from '@/modules/auth/redux/slices/main-slice';
import { RootState } from '@/core/redux/store';
import { LoadingGlobal } from '@/core/components';
import DialogManager from '@/core/services/dialog/dialogManager';
import { ToastProvider } from './core/services/toast/toastProvider';
import { useCordova } from '@/core/hooks';

function App() {
  const dispatch = useDispatch();
  const { initialized, loading, sessionData } = useSelector(
    (state: RootState) => state.auth.main
  );

  // Initialize Cordova at application level
  const cordovaInfo = useCordova();

  useEffect(() => {
    // Log Cordova initialization status
    if (cordovaInfo) {
      console.log('Cordova initialized:', cordovaInfo);
    }
  }, [cordovaInfo]);

  useEffect(() => {
    // Skip if already loading or if session data already exists
    if (loading || sessionData) {
      return;
    }

    // skip if location path contains /auth/sso
    const isSSOPath =
      window.location.pathname.indexOf('/auth/sso') !== -1 ||
      window.location.hash?.indexOf('auth/sso') !== -1;
    if (isSSOPath) {
      dispatch(appLoaded());
      return;
    }

    // Attempt to retrieve token and clientId from localStorage or last session data
    const sessionDataStr = localStorage.getItem('LastLoginUserData');
    const storedSessionData = JSON.parse(sessionDataStr || '{}');
    const token =
      localStorage.getItem('token') || storedSessionData.Token?.TokenValue;
    const clientId =
      localStorage.getItem('clientId') || storedSessionData.Client?._id || '';

    // test app
    // dispatch(
    //   getDataSessionRequest({
    //     token: 'tOI96REka1766139865468547689330',
    //     clientId: '693677b6dcf585bdeab55ec9',
    //   })
    // );
    // return;

    if (token) {
      dispatch(getDataSessionRequest({ token, clientId }));
    } else {
      dispatch(appLoaded());
    }
  }, [dispatch, loading, sessionData]);

  return (
    <>
      <ToastProvider>
        {initialized && <AppRouter />}
        <LoadingGlobal />
        <DialogManager />
      </ToastProvider>
    </>
  );
}

export default App;
